import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from '@tcc/crate';

import { splitView } from './SplitViewButton.css';

function SplitViewButton({ onClick, show }) {
  if (!show) return null;
  
  return (
    <Button
      className={splitView}
      data-test-id="dmb-split-view"
      mode="map"
      onClick={onClick}
    >
      <Icon glyph={Icon.set.SPLIT_VIEW} />
    </Button>
  );
}

SplitViewButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  show: PropTypes.bool,
};

export default SplitViewButton;
